import { DateRangeOptionType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/DateRangeOptionType";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ActivityStatus } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ActivityStatus";
import { TopFilterType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/TopFilterType";
import { ThreadType } from "../../../../../Wrap/Constants/Enums/Domain/ThreadType";
import { CoachMarkerSetType } from "../../../../../Wrap/Models/Models/CoachMarkers/CoachMarkerSetType";
import { ICoachMarkerPageConfig } from "../../../../Shared/CoachMarkers/CoachMarkerContext";

import { CoachMarkerStepPosition } from "../../../../Shared/CoachMarkers/CoachMarker";

import React from "react";
import { EmailFrequency } from "../../../../../Wrap/Constants/Enums/Notification/EmailFrequency";
import { NotificationDateRangeType } from "../../../../../Wrap/Constants/Enums/Client/NotificationFilter/NotificationDateRangeType";

export type DashboardDateRangeOption =
    | "Past month"
    | "Past tax year"
    | "Current tax year"
    | "Past year"
    | "Past 6 months"
    | "Past 3 months"
    | "Custom";
export const DashboardDateRangeOptions = [
    "Past tax year",
    "Current tax year",
    "Past year",
    "Past 6 months",
    "Past 3 months",
    "Past month",
    "Custom",
];

export const DateRangeOptionTypeMap = {
    [DateRangeOptionType.PastTaxYear]: "Past tax year",
    [DateRangeOptionType.CurrentTaxYear]: "Current tax year",
    [DateRangeOptionType.PastYear]: "Past year",
    [DateRangeOptionType.PastSixMonths]: "Past 6 months",
    [DateRangeOptionType.Custom]: "Custom",
    [DateRangeOptionType.PastThreeMonths]: "Past 3 months",
    [DateRangeOptionType.PastMonth]: "Past month",
};

export const FilterActivityStatusMap = {
    [ActivityStatus.NotSpecified]: "All",
    [ActivityStatus.Submitted]: "Incomplete",
    [ActivityStatus.Pending]: "Incomplete",
    [ActivityStatus.Cancelled]: "Cancelled",
    [ActivityStatus.Complete]: "Complete",
    [ActivityStatus.AwaitingAuthorisation]: "Awaiting Authorisation",
    [ActivityStatus.PendingTransferOnly]: "Transfers - In Progress",
    [ActivityStatus.RejectTransferOnly]: "Rejected",
};

export const filterActivityStatusOptions = [
    ActivityStatus.NotSpecified,
    ActivityStatus.Pending,
    ActivityStatus.Cancelled,
    ActivityStatus.Complete,
    ActivityStatus.AwaitingAuthorisation,
    ActivityStatus.PendingTransferOnly,
];

export const filterActivityStatusOptionsForNonTransferWizards = [
    ActivityStatus.NotSpecified,
    ActivityStatus.Pending,
    ActivityStatus.Cancelled,
    ActivityStatus.Complete,
    ActivityStatus.AwaitingAuthorisation,
];

export const filterTransferStatusOptions = [
    ActivityStatus.NotSpecified,
    ActivityStatus.Cancelled,
    ActivityStatus.Complete,
    ActivityStatus.PendingTransferOnly,
    ActivityStatus.RejectTransferOnly,
];

export const ProcessTypeMapForNew = {
    [ProcessType.NotSpecified]: "All",
    [ProcessType.NewBusiness]: "New Business",
    [ProcessType.Quote]: "Quote",
    [ProcessType.NewQuoteExistingClient]: "New Quote Existing Client",
    [ProcessType.NewBusinessExistingClient]: "New Business Existing Client",
    [ProcessType.AddRegularPayment]: "Add Regular Payment",
    [ProcessType.EditRegularPayment]: "Edit Regular Payment",
    [ProcessType.AddSinglePaymentorTransfer]: "Add Single Payment/Transfer",
    [ProcessType.Transfer]: "Transfer in Progress",
    [ProcessType.WhatIfTool]: "What if tool",
    [ProcessType.NoChangeTool]: "No Change Tool",
};

export const ProcessTypeOptionsForNew = [
    ProcessType.NotSpecified,
    ProcessType.NewBusiness,
    ProcessType.Quote,
    ProcessType.NewQuoteExistingClient,
    ProcessType.NewBusinessExistingClient,
    ProcessType.AddRegularPayment,
    ProcessType.EditRegularPayment,
    ProcessType.AddSinglePaymentorTransfer,
    ProcessType.Transfer,
    ProcessType.ServicesNewClient,
    ProcessType.ServicesNewIsa,
    ProcessType.WhatIfTool,
];

export const TopFilterTypeOptions = [TopFilterType.All, TopFilterType.New, TopFilterType.Legacy];

export const ProcessTypeOptionsMapForLegacy = {
    [ProcessType.NotSpecified]: "All",
    [ProcessType.AddLegacyData]: "Add Legacy Data",
    [ProcessType.NewContributionWrapper]: "New Contribution / Wrapper",
    [ProcessType.ExistingClientNewBusiness]: "Existing Client – New Business",
    [ProcessType.ChangeContribution]: "Change Contribution",
    [ProcessType.AdvancedSearch]: "Advanced Search",
    [ProcessType.ReviewFinancialPlan]: "Review Financial Plan",
    [ProcessType.OverallWrapChargeSummary]: "Overall Wrap Charge Summary",
    [ProcessType.RegularReviewRebalance]: "Regular Review / Rebalance",
    [ProcessType.AccountOpeningForTrusts]: "Account Opening for Trusts",
    [ProcessType.BulkTrade]: "Bulk Trade",
    [ProcessType.BulkRebalance]: "Bulk Rebalance",
    [ProcessType.BestPricing]: "Best Pricing",
    [ProcessType.MaintainAdviserCharging]: "Maintain Adviser Charging",
    [ProcessType.ServicesNewClient]: "Services New Client",
    [ProcessType.ServicesNewIsa]: "Services New ISA",
    [ProcessType.NewTransferRereg]: "New Transfer / Rereg",
    [ProcessType.CapitalGainsScenarioTool]: "Capital Gains Scenario Tool",
    [ProcessType.NewClientNewBusiness]: "New Client – New Business (including quote)",
    [ProcessType.MandateSetup]: "Mandate Setup",
    [ProcessType.MandateManagement]: "Mandate Management",
    [ProcessType.PpToIsaFeedTool]: "PP to ISA Feed Tool",
    [ProcessType.MandateModelSwitch]: "Mandate Model Switch",
};

export const ProcessTypeOptionsMapForLegacyActivityTab = {
    [ProcessType.NotSpecified]: "All",
    [ProcessType.AddLegacyData]: "Add Legacy Data",
    [ProcessType.NewContributionWrapper]: "New Contribution / Wrapper",
    [ProcessType.ExistingClientNewBusiness]: "Existing Client – New Business",
    [ProcessType.ChangeContribution]: "Change Contribution",
    [ProcessType.AdvancedSearch]: "Advanced Search",
    [ProcessType.ReviewFinancialPlan]: "Review Financial Plan",
    [ProcessType.OverallWrapChargeSummary]: "Overall Wrap Charge Summary",
    [ProcessType.RegularReviewRebalance]: "Regular Review / Rebalance",
    [ProcessType.AccountOpeningForTrusts]: "Account Opening for Trusts",
    [ProcessType.BulkTrade]: "Bulk Trade",
    [ProcessType.BulkRebalance]: "Bulk Rebalance",
    [ProcessType.BestPricing]: "Best Pricing",
    [ProcessType.MaintainAdviserCharging]: "Maintain Adviser Charging",
    [ProcessType.ServicesNewClient]: "Services New Client",
    [ProcessType.ServicesNewIsa]: "Services New ISA",
    [ProcessType.NewTransferRereg]: "New Transfer / Rereg",
    [ProcessType.CapitalGainsScenarioTool]: "Capital Gains Scenario Tool",
    [ProcessType.NewClientNewBusiness]: "New Client – New Business (including quote)",
    [ProcessType.PpToIsaFeedTool]: "PP to ISA Feed Tool",
    [ProcessType.MandateModelSwitch]: "Mandate Model Switch",
};

export const ProcessTypeOptionsForLegacy = [
    ProcessType.NotSpecified,
    ProcessType.ExistingClientNewBusiness,
    ProcessType.OverallWrapChargeSummary,
    ProcessType.RegularReviewRebalance,
    ProcessType.AccountOpeningForTrusts,
    ProcessType.BulkTrade,
    ProcessType.BulkRebalance,
    ProcessType.MaintainAdviserCharging,
    ProcessType.CapitalGainsScenarioTool,
    ProcessType.NewClientNewBusiness,
    ProcessType.MandateSetup,
    ProcessType.MandateManagement,
    ProcessType.PpToIsaFeedTool,
];

export const ProcessTypeOptionsForLegacyActivityTab = [
    ProcessType.NotSpecified,
    ProcessType.ExistingClientNewBusiness,
    ProcessType.OverallWrapChargeSummary,
    ProcessType.RegularReviewRebalance,
    ProcessType.AccountOpeningForTrusts,
    ProcessType.MaintainAdviserCharging,
    ProcessType.CapitalGainsScenarioTool,
    ProcessType.NewClientNewBusiness,
    ProcessType.PpToIsaFeedTool,
];

export const TopFilterTypeMap = {
    [TopFilterType.All]: "All",
    [TopFilterType.New]: "New",
    [TopFilterType.Legacy]: "Legacy",
};

export const FilterProductTypeMap = {
    [SubAccountType.NotSpecified]: "All",
    [SubAccountType.StocksIsa]: "ISA Stocks and Shares",
    [SubAccountType.Npr]: "SIPP",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Cash Account",
    [SubAccountType.CashIsa]: "Cash ISA",
    [SubAccountType.OnshoreBond]: "Onshore Bond",
    [SubAccountType.OffshoreBond]: "Offshore Bond",
};

export const FilterProductTypeOption = [
    SubAccountType.NotSpecified,
    SubAccountType.StocksIsa,
    SubAccountType.Npr,
    SubAccountType.PersonalPortfolio,
    SubAccountType.WrapCash,
    SubAccountType.CashIsa,
    SubAccountType.OnshoreBond,
    SubAccountType.OffshoreBond,
];

export enum DashboardTab {
    Workflow = "Workflow",
    Notification = "Notifications",
}

export const DashboardTabArray = [DashboardTab.Workflow, DashboardTab.Notification];

export const transferMsg = {
    [ActivityStatus.ReviewedTransferOnly]:
        "We are now processing your transfer application. Please remember that if the transfer cannot be carried out electronically, we will need a signed transfer authority.",
    [ActivityStatus.Complete]: "This transfer is now complete.",
    [ActivityStatus.RejectTransferOnly]: "This transfer is rejected.",
    [ActivityStatus.Cancelled]: "This transfer is cancelled",
    [ActivityStatus.PendingTransferOnly]: "Thank you for submitting your transfer application.",
};

export const EventTypeMap = {
    [ThreadType.Alert]: "Action required",
    [ThreadType.ImportantInformation]: "Important information",
    [ThreadType.Information]: "Information",
    [ThreadType.NotSpecified]: "All",
};

export const EventTypeOptions = [
    ThreadType.NotSpecified,
    ThreadType.Alert,
    ThreadType.ImportantInformation,
    ThreadType.Information,
];

export const EmailFrequencyOptions = [
    EmailFrequency.NotSpecified,
    EmailFrequency.Never,
    EmailFrequency.Daily,
    EmailFrequency.Weekly,
    EmailFrequency.Monthly,
];

export const EmailFrequencyMap = {
    [EmailFrequency.NotSpecified]: "",
    [EmailFrequency.Never]: "Never",
    [EmailFrequency.Daily]: "Daily",
    [EmailFrequency.Weekly]: "Weekly",
    [EmailFrequency.Monthly]: "Monthly",
};

export const getDashboardCoachmarkerConfig = (isAppStoreEnabled?: boolean): ICoachMarkerPageConfig => {
    const steps = [
        {
            title: "Quick search",
            stepPosition: CoachMarkerStepPosition.Bottom,
            positionTop: 70,
            positionLeft: 0,
            stepKey: "secured-search",
            description: (
                <>
                    Search for a client or account quickly using first name(s), surname, organisation or account number
                    from anywhere in the platform using this search bar.
                </>
            ),
        },
        {
            title: "Platform navigation",
            stepPosition: CoachMarkerStepPosition.Right,
            stepKey: "secured-main-navigation",
            positionLeft: 110,
            positionTop: 87,
            description: (
                <>
                    <p>Navigate the main platform areas from here:</p>

                    <p>
                        <b>Dashboard</b> - Platform homepage with workflow, notifications and alerts.
                    </p>

                    <p>
                        <b>Clients</b> - An advanced search which allows you to search by clients, consolidated or
                        organisation accounts. You can search by more criteria here too, i.e. all clients with specific
                        products or who have active regular payments.
                    </p>

                    <p>
                        <b>Business management</b> - A hub for management information and firm level data.
                    </p>

                    <p>
                        <b>Tools and Literature</b> - For research tools, calculators and literature library with guides
                        and forms.
                    </p>
                </>
            ),
        },
        {
            title: "Menu system",
            stepPosition: CoachMarkerStepPosition.BottomLeft,
            positionLeft: -286,
            positionTop: 70,
            stepKey: "custom-navigation",
            description: (
                <>
                    The platform menu system is dynamic and provides access to tasks, information and transactional
                    activities within context of the position you are on the platform.
                </>
            ),
        },
        {
            title: "Workflow and notifications",
            stepPosition: CoachMarkerStepPosition.BottomRight,
            stepKey: "workflow-notifications-tab",
            positionLeft: -3,
            positionTop: 48,
            description: (
                <>
                    Workflow and notifications allow you to manage your firms workflow and view activity specific to
                    you. A variety of filters can be set up to suit different needs across both Workflow and
                    Notifications and help manage the information you see.
                </>
            ),
        },
        {
            title: "Profile",
            stepPosition: CoachMarkerStepPosition.Right,
            stepKey: "profile",
            positionLeft: 75,
            positionTop: -30,
            description: (
                <>
                    Your profile contains settings such as change password or switch between light and dark mode for a
                    more personal user interface experience.
                </>
            ),
        },
        {
            title: "Platform tips",
            stepPosition: CoachMarkerStepPosition.Right,
            stepKey: "platform-tips",
            positionLeft: 110,
            positionTop: -20,
            description: (
                <>
                    When there are tips available to view on a page, this button will appear and you can open them from
                    here.
                </>
            ),
        },
    ];

    if (isAppStoreEnabled) {
        steps.push({
            title: "App Store",
            stepKey: "appstore",
            stepPosition: CoachMarkerStepPosition.Right,
            positionLeft: 110,
            positionTop: -20,
            description: <>Access an ecosystem of your favourite apps to optimise your workflow.</>,
        });
    }

    return {
        coachMarkerSetType: CoachMarkerSetType.FnzOneDashboard,
        steps,
    };
};

export const notificationsCoachmarkerConfig: ICoachMarkerPageConfig = {
    coachMarkerSetType: CoachMarkerSetType.FnzOneNotifications,
    steps: [
        {
            title: "Manage notifications",
            stepPosition: CoachMarkerStepPosition.BottomLeft,
            stepKey: "manage-notifications",
            positionLeft: -325,
            positionTop: 50,
            description: (
                <>
                    You can set what type of activities you want to receive notifications for and manage how you are
                    alerted to them.
                </>
            ),
        },
        {
            title: "Filters",
            stepPosition: CoachMarkerStepPosition.BottomLeft,
            stepKey: "notifications-filter",
            positionLeft: -323,
            positionTop: 50,
            description: (
                <>
                    Quickly filter read and unread notifications by event category, event type, client name or account,
                    and date.
                </>
            ),
        },
    ],
};

export const NotificationDateRangeTypeMap = {
    [NotificationDateRangeType.PastWeek]: "Past week",
    [NotificationDateRangeType.PastMonth]: "Past month",
    [NotificationDateRangeType.PastThreeMonths]: "Past 3 months",
    [NotificationDateRangeType.PastSixMonths]: "Past 6 months",
    [NotificationDateRangeType.PastYear]: "Past year",
};

export const NotificationDateRangeTypeOptions = [
    NotificationDateRangeType.PastWeek,
    NotificationDateRangeType.PastMonth,
    NotificationDateRangeType.PastThreeMonths,
    NotificationDateRangeType.PastSixMonths,
    NotificationDateRangeType.PastYear,
];

export const enum OpreationType {
    Add = 1,
    Delete = 2,
    Save = 3,
    Reorder = 4,
}
